// @ts-nocheck
import InputLabelField from '@/components/form-control/InputLabelField'
import { CONFIG_NAME_MAX_LENGTH } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import { useConfigUI } from '@/features/config/context'
import useSearchSubAreaId from '@/features/config/hooks/areasandzones/useSearchSubAreaId'
import useUpdateSubArea from '@/features/config/hooks/areasandzones/useUpdateSubArea'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  Container,
  FormControl,
  Stack,
  Typography,
} from '@mui/material'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import useTranslation from '@/hooks/useTranslation'


interface EditSubAreaViewProps {
  id?: number
  parentId?: string
  name?: string
}

const schema = yup
  .object({
    name: yup
      .string()
      .required('Sub Area Name is required')
      .max(CONFIG_NAME_MAX_LENGTH, `Maximum ${CONFIG_NAME_MAX_LENGTH} characters`),
  })
  .required()

const EditSubAreaView = ({ id, parentId, name }: EditSubAreaViewProps) => {
  const { t } = useTranslation()
  const { closeSidebar } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const { mutate: updateSubArea, isLoading: loadingUpdateSubArea } =
    useUpdateSubArea()

  const inputRefSiteName = useRef<HTMLInputElement>(null)

  const form = useForm({
    defaultValues: {
      name: name,
      id: id,
      parentId: parentId,
      parentName: '',
    },
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])

  const { data } = useSearchSubAreaId(interfaceId, Number(parentId))

  useEffect(() => {
    if (data) {
      form.reset({
        parentName: data.name,
      })
    }
  }, [data, form])

  const handleSave = (data: any) => {
    updateSubArea({
      id: Number(id),
      parentId: parentId ? parentId : '',
      interfaceId: interfaceId,
      name: data.name,
    })
  }

  return (
    <Container sx={{ maxWidth: '450px' }}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <Stack sx={{ padding: '34px 18px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              marginBottom: '20px',
              width: '377px',
              '& .MuiButtonBase-root': {
                height: '26px',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '14px',
                color: '#000000',
              }}
            >
              {t('editSubarea')}
            </Typography>
            <Stack direction="row">
              <Button
                variant="secondary"
                sx={{ marginRight: '7px', width: '85px' }}
                onClick={() => closeSidebar()}
              >
                {t('commonActionsCancel')}
              </Button>
              <LoadingButton
                loading={loadingUpdateSubArea}
                variant="primary"
                sx={{ minWidth: '72px' }}
                type="submit"
              >
                {t('commonActionsSave')}
              </LoadingButton>
            </Stack>
          </Stack>

          <Stack>
            {Number(parentId) !== 0 ? (
              <FormControl
                variant="standard"
                sx={{
                  minWidth: '377px',
                  minHeight: '50px',
                  marginTop: '8px',
                  backgroundColor: 'background.default',
                  borderRadius: '4px',
                }}
                disabled
              >
                <InputLabelField
                  name="parentName"
                  form={form}
                  label={t('AreaName')}
                  padding="8px 12px"
                  disabled={true}
                />
              </FormControl>
            ) : null}
          </Stack>

          <InputLabelField
            name="name"
            form={form}
            maxLength={CONFIG_NAME_MAX_LENGTH}
            label={t('SubAreaName')}
            inputRef={inputRefSiteName}
            style={{
              height: 50,
              borderRadius: '4px',
              width: { xs: '377px' },
              marginTop: '8px',
            }}
            padding="8px 16px"
          />
        </Stack>
      </form>
    </Container>
  )
}

export default EditSubAreaView
